export default "__VITE_ASSET__Q2ub8z0L__"